import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-brand-green text-brand-bone">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="/images/fabcrops_logo_transparent.png"
              alt="Fab Crops by P.S.IMPEX"
              className="h-20 w-auto object-contain brightness-0 invert mb-4"
            />
            <p className="text-brand-bone/70 text-sm font-sans leading-relaxed">
              Premium royal basmati rice, cultivated with heritage and exported
              with trust to markets across the globe.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] text-brand-gold font-sans font-semibold mb-6">
              Navigate
            </h4>
            <div className="flex flex-col gap-3">
              {[
                { name: "Home", path: "/" },
                { name: "About Us", path: "/about" },
                { name: "Products", path: "/products" },
                { name: "Exports", path: "/exports" },
                { name: "Certifications", path: "/certifications" },
                { name: "News & Vlogs", path: "/blog" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-${link.name.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-brand-bone/70 hover:text-brand-gold text-sm font-sans transition-colors duration-300 flex items-center gap-1 group"
                >
                  {link.name}
                  <ArrowUpRight
                    size={12}
                    className="opacity-0 group-hover:opacity-100 transition-opacity"
                  />
                </Link>
              ))}
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] text-brand-gold font-sans font-semibold mb-6">
              Products
            </h4>
            <div className="flex flex-col gap-3">
              {[
                "1121 Basmati Rice",
                "1718 Basmati Rice",
                "1401 Basmati Rice",
                "1509 Basmati Rice",
                "Pusa Basmati Rice",
                "Non-Basmati Rice",
              ].map((item) => (
                <span
                  key={item}
                  className="text-brand-bone/70 text-sm font-sans"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] text-brand-gold font-sans font-semibold mb-6">
              Get in Touch
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href="tel:+919872227812"
                data-testid="footer-phone"
                className="flex items-center gap-3 text-brand-bone/70 hover:text-brand-gold text-sm font-sans transition-colors"
              >
                <Phone size={16} className="text-brand-gold" />
                +91-9872227812
              </a>
              <a
                href="mailto:info@psimpex.in"
                data-testid="footer-email"
                className="flex items-center gap-3 text-brand-bone/70 hover:text-brand-gold text-sm font-sans transition-colors"
              >
                <Mail size={16} className="text-brand-gold" />
                info@psimpex.in
              </a>
              <div className="flex items-start gap-3 text-brand-bone/70 text-sm font-sans">
                <MapPin size={16} className="text-brand-gold mt-0.5 shrink-0" />
                12029, Sahibzada Ajit Singh Nagar, Ludhiana, Punjab, India
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-brand-bone/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-brand-bone/50 text-xs font-sans">
              &copy; {new Date().getFullYear()} P.S.IMPEX. All rights reserved.
            </p>
            <p className="text-brand-bone/40 text-xs font-sans">
              P.S.IMPEX | Premium Rice Exporters | Punjab, India
            </p>
            <div className="flex items-center gap-6">
              <span className="text-brand-bone/50 text-xs font-sans">
                FSSAI Certified
              </span>
              <span className="text-brand-bone/50 text-xs font-sans">
                APEDA Registered
              </span>
              <span className="text-brand-bone/50 text-xs font-sans">
                ISO 9001:2015
              </span>
              <span className="text-brand-bone/50 text-xs font-sans">
                LEI Registered
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
